var map = {
	"./GABBEH - Due lati (116 x 110 cm).jpg": 5152,
	"./JAJIM SHAHSAVAN - (175 x 140 cm).jpg": 4557,
	"./KILIM KURDO - (160 x 95 cm).jpg": 9795,
	"./Kilim Caucasico (290 x 170 cm).jpg": 256,
	"./Kilim Sofreh (120 x 120 cm).jpg": 7511,
	"./Kilim Sofreh (130 x 120 cm).jpg": 1472,
	"./Kilim Varamin (320 x 165 cm).jpg": 4163,
	"./Kilim caucasico - (150 x125 cm).jpg": 1502,
	"./Kilim varamin - (200 x 140 cm).jpg": 2596,
	"./Kilim varamin - (265 x 175 cm).jpg": 7343
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6203;